module.exports = __webpack_public_path__ + "assets/img/news-banner.79f5e8a5.png";